import { useWorkspaceCache, useWorkspaceSuspenseQuery } from '@/entities/workspace/query';

export const useWorkspace = () => {
  const workspaceQuery = useWorkspaceSuspenseQuery();
  const { refetch } = useWorkspaceCache();

  return {
    workspace: workspaceQuery.data,
    refetch,
  };
};

export { useWorkspaceCache };
